import { useEffect, useState } from "react";
import { fetchStores, updateStore } from "../api/storeApi";
import { Store } from "../types/store";

const useStoreList = () => {
  const [stores, setStores] = useState<Store[]>([]);
  const [params, setParams] = useState({
    store_cd_or_name: "",
    pref_cd: "",
    store_cd: "",
    status_flag: 1,
    managed_logistics_cd: "",
    limit: 50,
    offset: 1,
  });
  const [total, setTotal] = useState<number>(0);
  const [loading, setLoading] = useState(false);

  const fetchData = async (refetch = false) => {
    setLoading(true);
    try {
      const data = await fetchStores({
        ...params,
        offset: refetch ? 1 : params.offset,
        status_flag: params.status_flag || undefined,
      });
      if (params.offset > 1 && !refetch) {
        setStores((prevStores) => [...prevStores, ...data.list]);
      } else {
        setStores(data.list);
      }
      setTotal(data.total);
    } catch (error) {
      console.error("Error fetching stores:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [params.offset]);

  useEffect(() => {
    const handleScroll = () => {
      if (window.innerHeight + window.scrollY >= document.documentElement.scrollHeight) {
        if (total === stores.length) return;
        setParams((prevParams) => ({ ...prevParams, offset: prevParams.offset + 1 }));
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [total, stores.length]);

  const handleUpdateStore = async (store?: Store) => {
    if (store) {
      const response = await updateStore(store);
      if (response.status === 200) {
        fetchData(true);
      }
    }
  };

  const handleSearch = () => {
    const shouldFetch = params.offset === 1;
    setParams({ ...params, offset: 1 });
    if (shouldFetch) {
      fetchData();
    }
  };

  return { stores, total, setParams, params, fetchData, handleSearch, handleUpdateStore, loading };
};

export default useStoreList;
